<template>
  <v-card class="pa-3 mb-3">
   
     <FilterCheckSelect ref="fcsSecim" :show="dialog" @selectedClick="filterSecilenler"  @close="dialog=false" ></FilterCheckSelect>
    <!-- <v-dialog v-model="dialog" max-width="500px">
  <v-card>
        <v-card-title class="headline">
        Seçim
        </v-card-title>

        <v-card-text>
      
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">İptal</v-btn>
          <v-btn color="primary" text @click="saveTitle">Kaydet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->



    <!-- <v-radio-group v-model="group.goster" row>
      <v-radio label="Göster" value="goster"></v-radio>
      <v-radio label="Gizle" value="gizle"></v-radio>
    </v-radio-group> -->
    <v-row align="center">
      <v-col cols="3">
        <v-select v-model="group.logic" :items="compares" item-text="name" item-value="id" label="Logic" dense />
      </v-col>
      <v-col cols="9" class="text-right">
        <v-btn small color="primary" @click="addCondition">Koşul Ekle</v-btn>
        <v-btn small color="secondary" @click="addGroup">Grup Ekle</v-btn>
      </v-col>
    </v-row>

    <v-list dense>
      <v-list-item v-for="(cond, i) in group.conditions" :key="i">
        <!-- Eğer alt grupsa recursive render -->
        <!-- <ConditionBuilder v-if="cond.conditions" v-model="group.conditions[i]" :fields="fields" /> -->
         <div v-if="cond.conditions" class="d-flex align-start w-100">
    <ConditionBuilder 
      v-model="group.conditions[i]" 
      :fields="fields" 
      class="flex-grow-1"
    />
    <v-btn icon small color="error" class="mt-2 ml-2" @click="removeCondition(i)">
      <v-icon small>mdi-folder-remove</v-icon>
    </v-btn>
  </div>
        <!-- Yoksa tek koşul -->
        <div v-else class="d-flex align-center">
          <v-select class="mr-2 select-width"
 v-model="cond.field" :items="fields" label="Alan" item-text="name" item-value="id" dense width="250"
            />
          <v-select v-model="cond.operator" :items="operators" item-text="name" item-value="id" label="Operatör" dense
            class="mr-2" />
          <v-text-field v-model="cond.value" label="Değer" dense class="mr-2"     append-outer-icon="mdi-apps"   @click:append-outer="txtDegerOuterClick(cond)">
          </v-text-field>
                   <v-text-field v-model="cond.description" label="Hata Mesajı" dense class="mr-2" >
          </v-text-field>
          <v-btn icon small @click="removeCondition(i)">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import FilterCheckSelect from './FilterCheckSelect.vue';
export default {
  components: {
    FilterCheckSelect,
  
  },
  name: "ConditionBuilder",
  props: {
    value: { type: Object, required: true },
    fields: { type: Array, required: true }
  },
  data() {
    return {
selectedConIndex:-1,
selectedCon:null,
dialog:false,
      compares: [
        { id: "AND", name: "Ve" },
        { id: "OR", name: "Veya" }
      ],
      operators: [
        { id: "equals", name: "Eşit" }
        , { id: "notEquals", name: "Eşit Değil" }
        , { id: "contains", name: "İçerir" }
        , { id: "greater", name: "Büyük" }
        , { id: "greaterOrEqual", name: "Büyük veya Eşit" }
        , { id: "less", name: "Küçük" }
        , { id: "lessOrEqual", name: "Küçük veya Eşit" }
        , { id: "in", name: "Liste İçinde" }
      ],
      operators1: [
        "equals",
        "notEquals",
        "contains",
        "greater",
        "greaterOrEqual",
        "less",
        "lessOrEqual",
        "in",//virgülle ayrılmış liste içinde var mı(ÖRN:Sinop,Boyabat,amasya içinde amasya var mı)
      ]
    };
  },
  computed: {
    group: {
      get() {
        console.log("Computed group:",this.value);
        if (!this.value) { 

        return  {  logic: "AND", conditions: [] }
         }
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {

    filterSecilenler(v){
   
this.selectedCon.value=v.join();
this.dialog=false;  
    },
    txtDegerOuterClick(cond){
      this.selectedCon=cond;
      if (cond.value) {
          this.$refs.fcsSecim.setSelected(cond.value.split(","));
      }
      else
      {
        this.$refs.fcsSecim.setSelected([]);
  
      }
    
this.dialog=true;
    },
    addCondition() {
      console.log("Add Fields:",this.group.conditions);
       let tempItem= this.fields.length>0 ? this.fields[0].id : null;
      this.group.conditions.push({
        field: tempItem,
        operator: "equals",
        value: "",
        description: "" 
      });
    },
    addGroup() {
      this.group.conditions.push({
        logic: "AND",
        conditions: []
      });
    },
    removeCondition(index) {
      this.group.conditions.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.select-width {
  width: 150px;
}
.v-card.pa-3.mb-3 {
  border-left: 3px solid #e0e0e0 !important;
}
</style>



<!-- <template>
  <div class="space-y-4 p-4">
    <button class="px-3 py-2 bg-blue-600 text-white rounded" @click="addFilter">
      + Yeni Filtre
    </button>

    <div v-for="(f, index) in filters" :key="index" class="p-3 border rounded-md space-y-3 bg-gray-50">

      <select v-model="f.field" @change="onFieldChange(f)" class="border p-2 rounded w-full">
        <option v-for="item in filterableItems" :key="item.fieldKey" :value="item.id">
          {{ item.label }}
        </option>
      </select>


      <select v-model="f.operator" @change="update" class="border p-2 rounded w-full">
        <option value="=">Eşit</option>
        <option value="!=">Eşit Değil</option>
        <option value=">=">Büyük Eşit</option>
        <option value="<=">Küçük Eşit</option>
        <option value=">">Büyük</option>
        <option value="<">Küçük</option>
        <option value="contains">İçerir</option>
        <option value="in">Liste İçinde</option>
      </select>


      <component
        :is="getInputComponent(f)"
        v-model="f.value"
        class="border p-2 rounded w-full"
        @input="update"
      />

      <button class="px-3 py-1 bg-red-500 text-white rounded" @click="removeFilter(index)">
        Sil
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      filters: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.filters = JSON.parse(JSON.stringify(val || []))
      }
    }
  },
  computed: {
    filterableItems() {
      return this.items;//.filter(x => x.filterable)
    }
  },
  methods: {
    addFilter() {
      const firstItem = this.items[0];
      if (!firstItem) return

      this.filters.push({
        field: firstItem.fieldKey,
        operator: this.getDefaultOperator(firstItem),
        value: null
      })
      this.update()
    },

    getDefaultOperator(item) {
      switch (item.filterType) {
        case "compare": return ">="
        case "contains": return "contains"
        default: return "="
      }
    },

    onFieldChange(filter) {
      const item = this.items.find(i => i.fieldKey === filter.field)
      filter.operator = this.getDefaultOperator(item)
      filter.value = null
      this.update()
    },

    update() {
      console.log("Update Dimik Filter:",this.filters);
      this.$emit("input", JSON.parse(JSON.stringify(this.filters)))
    },

    removeFilter(index) {
      this.filters.splice(index, 1)
      this.update()
    },

    getInputComponent(filter) {
      const item = this.items.find(i => i.fieldKey === filter.field)
      if (!item) return "input"

      switch (item.type) {
        case "number": return "input"
        case "text": return "input"
        case "select":
          return {
            props: ["value"],
            template: `
              <select :value="value" @change="$emit('input', $event.target.value)" class="border p-2 rounded w-full">
                <option v-for="opt in opts" :key="opt" :value="opt">{{ opt }}</option>
              </select>
            `,
            data() {
              return { opts: item.options }
            }
          }
      }
      return "input"
    }
  }
}
</script>

<style scoped>
</style> -->
